// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + "68bd48da2660a696f677" + ".css";
};